import TimeBetween from '@/components/ezuro/common/TimeBetween.vue'
import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'
import Days from '@/components/ezuro/constants/shifts/edit/Days.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from 'moment';

const defaultEl = {
  id: null,
  type: 'days_one',
  time_start: '',
  time_end: '',
  length_in_minutes: 0,
  days: {
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    7: false
  }
};

export default {
  name: 'Edit',
  components: {
    TimeBetween,
    MinutesToText,
    Days
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    },
    userApiId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    };
  },
  validations: {
    editEl: {
      type: { required },
      time_start: { },
      time_end: { },
      length_in_minutes: { },
      days: { }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('work-schedule.availability.actions.edit');
      }
      return this.$t('work-schedule.availability.actions.new');
    },
    canEdit () {
      return !this.isLoading;
    },
    typeOptions () {
      const types = [
        { value: 'days_one', text: this.$t('shift.type.options.days_one') },
        { value: 'days_many', text: this.$t('shift.type.options.days_many') }
      ];
      return types;
    }
  },
  methods: {
    show (elData) {
      this.v$.$reset();
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);

        const today = moment();
        this.editEl.time_end = new Date(today.format('YYYY-MM-DD') + ' ' + this.editEl.time_end);
        this.editEl.time_start = new Date(today.format('YYYY-MM-DD') + ' ' + this.editEl.time_start);

        const daysObj = {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false
        };
        for (const key in this.editEl.days) {
          if (typeof daysObj[this.editEl.days[key]] !== 'undefined') {
            daysObj[this.editEl.days[key]] = true;
          }
        }
        this.editEl.days = daysObj;
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    updateDays (data) {
      this.editEl.days = data;
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        reqData.user_id = this.userApiId;
        for (const key of Object.keys(defaultEl)) {
          if (key == 'days') {
            let dataString = '';
            Object.keys(this.editEl.days).forEach(dayKey => {
              if (this.editEl.days[dayKey]) {
                dataString += dayKey;
              }
            });
            reqData[key] = dataString;
            continue;
          } else if (['time_start', 'time_end'].includes(key)) {
            reqData[key] = moment(this.editEl[key]).format('HH:mm');
            continue;
          }
          reqData[key] = this.editEl[key];
        }
        this.ApiRequest.request('ezuro/availability/save' + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
